import BrandModelListPanel from './brandModelListPanel.container';

export default BrandModelListPanel;